
import React, { Component } from 'react';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';
import IconButton from "@material-ui/core/IconButton";
import ClearIcon from "@material-ui/icons/Clear";
import styled, { css } from 'styled-components';

import { DebouncedTextField } from './Debounced';


const StyledTextField = styled(DebouncedTextField)`
  ${props => props.minimal && css`
    background: #F2F2F2;
    
    .MuiOutlinedInput-notchedOutline {
      border-width: 0;
    }
  `}
`;


export default class SearchWidget extends Component {

  render() {
    const { value, onChange, autoFocus, fullWidth, inputProps } = this.props;

    return (
      <StyledTextField
        InputProps={{
          placeholder: 'Поиск',
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
          endAdornment: (
            value && (
              <InputAdornment position="end">
                <IconButton onClick={() => onChange('')} size={'small'}>
                  <ClearIcon />
                </IconButton>
              </InputAdornment>
            )
          ),
          ...inputProps
        }}
        size="small"
        variant="outlined"
        autoFocus={autoFocus}
        fullWidth={fullWidth}
        {...this.props}
      />
    )
  }
}
